// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__txP_I","calendarButtons":"ClockData_calendarButtons__j7sVC"};